import { render, staticRenderFns } from "./Kalenderwoche.vue?vue&type=template&id=4e2f8cae&"
import script from "./Kalenderwoche.vue?vue&type=script&lang=js&"
export * from "./Kalenderwoche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports